import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    List,
    ListItem,
    Divider,
    Stack,
} from "@mui/material";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { surveillanceMap } from "./surveillanceMap";
import React from "react";
interface SurveillanceInfo {
    symbol: string;
    warningTitle: string;
    cautions: string[];
}

interface SurveillanceDialogProps {
    open: boolean;
    info: SurveillanceInfo;
    onConfirm: () => void;
    onClose: () => void;
}
export const SurveillanceWarningDialog = ({
    open,
    info,
    onConfirm,
    onClose
}: SurveillanceDialogProps) => {
    return (
        <Dialog open={open} onClose={onClose} >
            <DialogTitle sx={{ px: 2, py: 1 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <ReportProblemIcon color="warning" />
                    <Typography variant="h6">Regulatory caution</Typography>
                </Stack>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Typography variant="body1" sx={{ mb: 1, mt: 2 , textAlign: 'justify', lineHeight:1.5}}>
                    {info.symbol} has the following cautionary messages –
                </Typography>
                <List dense sx={{ pl: 3 }}>
                    {info.cautions.map((codeStr: string, i: number) => {
                        const code = Number(codeStr);
                        const [label, message] = surveillanceMap[code] ?? [];

                        return (
                            <React.Fragment key={i}>
                                <ListItem
                                    sx={{
                                        display: 'list-item',
                                        listStyleType: 'disc',
                                        pl: 1,
                                        py: 0,
                                        pb: 1
                                    }}
                                >
                                    <Typography variant="body2" component="span">
                                        {label ?? `Surveillance Code (${code})`}
                                    </Typography>
                                </ListItem>

                                {message && (
                                    <ListItem
                                        sx={{
                                            display: 'list-item',
                                            listStyleType: 'disc',
                                            pl: 1,
                                            py: 0,
                                        }}
                                    >
                                        <Typography variant="body2" component="span">
                                            {message}
                                        </Typography>
                                    </ListItem>
                                )}
                            </React.Fragment>
                        );
                    })}
                </List>
                <Typography fontSize={'12px'} sx={{ mt: 1,textAlign: 'justify', }}>
                    Please analyse the risks carefully before Proceeding.
                </Typography>

            </DialogContent>
            <Divider />
            <DialogActions sx={{ px:2, py:1}}>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm} variant="contained" color="primary">
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
};
